var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProducts2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 43.088,
    viewBox: "0 0 50 43.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-165 -396.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M215,412.364a5.689,5.689,0,0,1-1.015.989q-8.68,5.007-17.388,9.966a1.345,1.345,0,0,1-2-.4l-3.285-4.118v15.276c.182-.092.349-.17.51-.259q8.164-4.48,16.329-8.96a2.418,2.418,0,0,1,.669-.28,1.269,1.269,0,0,1,.907,2.32c-.313.2-.648.372-.976.552q-8.89,4.88-17.776,9.768a1.848,1.848,0,0,1-1.96,0q-9.19-4.886-18.409-9.719a1.565,1.565,0,0,1-.94-1.548c.021-3.336,0-6.673.017-10.009a.709.709,0,0,0-.415-.726c-1.1-.6-2.167-1.254-3.266-1.852a2.178,2.178,0,0,1-1-1.006v-.684c.119-.19.233-.383.358-.57,1.454-2.177,2.9-4.361,4.376-6.522a2.549,2.549,0,0,1,.929-.813q9.282-4.6,18.58-9.157a1.582,1.582,0,0,1,1.487-.03q9.338,4.42,18.678,8.835a2.093,2.093,0,0,1,.816.726c1.608,2.5,3.188,5.018,4.776,7.53Zm-41.2-7.283c.2.114.328.188.457.256q7.65,4.039,15.3,8.085a.811.811,0,0,0,.884-.009q7.387-4.068,14.786-8.113c.305-.167.606-.341.969-.546-.216-.114-.352-.194-.495-.261q-7.623-3.6-15.244-7.2a.869.869,0,0,0-.856.012q-4.977,2.467-9.968,4.908Zm14.884,29.049V418.812c-1.107,1.389-2.15,2.7-3.195,4.005a1.413,1.413,0,0,1-2.22.425l-10.538-6.029c-.147-.084-.3-.16-.5-.266,0,2.735.008,5.387-.01,8.039a.681.681,0,0,0,.437.7q7.229,3.8,14.447,7.615C187.618,433.575,188.133,433.843,188.682,434.131Zm7.4-13.465,15.843-9.068-3.315-5.231-16.652,9.128Zm-8.047-5.155-16.654-8.79-3.271,4.893,15.815,9.049Z",
    transform: "translate(0 2.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M493.35,589.147a1.486,1.486,0,1,1,1.492-1.478A1.472,1.472,0,0,1,493.35,589.147Z",
    transform: "translate(-284.312 -167.276)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts2);
export default __webpack_public_path__ + "static/media/products2.774c5a885d99abae93a1987ac05cc288.svg";
export { ForwardRef as ReactComponent };